export default "__VITE_ASSET__Lavzv_YK__"